"use client";
import { getCookie, setCookie } from "helpers/cookies";
import JobCardPc from "app/(new-pages)/components/JobCard/pc/index.pc";
import JobCountTracker from "components/ReportTracker/JobCountTracker";
import {
  jobCountSourceTracker,
  setJobViewCookiesTracker,
  viewJobSourceTracker
} from "components/ReportTracker/util";
import { postNotification } from "bossjob-remote/dist/clientStorage";
import { VipActivity } from "components/vipActivity";
import { Pagination as NewPagination } from "app/(new-pages)/components/Pagination";
import styles from "../../../style/index.module.scss";
import { fetchSearchSimilarJob } from "../../../service";
import { useState } from "react";

const MoreTablePc = ({ lang, dictionary, sessionid, similarJobs }) => {
  const { title, more_text, total_pages, condition = {} } = similarJobs || {};
  const isLogin = getCookie("sessionid") ? true : false;
  const [jobs, setJobs] = useState(similarJobs.jobs || []);
  const [page, setPage] = useState(similarJobs.page || 1);
  const jobsIds = (jobs || []).map((item) => item?.id).join(",");
  const reportTrackerData = {
    source: jobCountSourceTracker.jobsHiring,
    job_ids: jobsIds
  };

  const changeDetail = (item) => {
    if (item?.job_url) {
      const url = `/${lang}/${item.job_url}`;
      setJobViewCookiesTracker(setCookie, {
        source: viewJobSourceTracker.remoteSimilarJobList,
        reco_from: item?.reco_from || null,
        query_id: item?.query_id || null
      });
      window.open(url, "_blank");
    }
  };

  const handleClick = () => {
    let url = "";
    if (isLogin) {
      url = `/${lang}/my-jobs`;
      window.location.href = url;
    } else {
      postNotification("SHOW_LOGIN_MODAL");
    }
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchSearchSimilarJob({
      ...condition,
      page,
      size: 7
    }).then((res) => {
      setJobs(res.data?.data?.similar_jobs?.jobs || []);
      const element = document.getElementById("similarJobsTitles");
      element.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
  };

  return (
    <>
      <div className={styles.otherContent}>
        <div className={styles.otherMore_card}>
          <h2 id='similarJobsTitles'>{title}</h2>

          {jobs?.map((item, index) => {
            return (
              <JobCardPc
                key={item.job_id}
                item={item}
                index={index}
                currentIndex={null}
                changeDetail={() => changeDetail(item)}
                showChatBtn={true}
              />
            );
          })}

          {sessionid ? (
            total_pages > 1 ? (
              <div style={{ paddingTop: "20px" }}>
                <NewPagination
                  current={page}
                  total={total_pages * 7}
                  pageSize={7}
                  onChange={handleChangePage}
                />
              </div>
            ) : null
          ) : (
            <div className={styles.otherMore_seeMore}>
              {" "}
              <div onClick={handleClick}>{more_text}</div>{" "}
            </div>
          )}
        </div>

        <div className={styles.otherMore_hangBox}>
          <VipActivity lang={dictionary} style={{ marginBottom: "0", fontSize: 0 }} />
        </div>
      </div>

      <JobCountTracker data={reportTrackerData} />
    </>
  );
};

export default MoreTablePc;
